/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateMember.defs.js'
export { main as default } from './updateMember.defs.js'
